import React from 'react';
import { removeNoNumbersCharactersFromChangeEvent } from '../../Utils/inputFunctions';
import phoneMask from './phoneMask';

export default function InputPhone(props) {
  const [value, setValue] = React.useState('');

  return (
    <input
      {...props}
      value={phoneMask(value)}
      onChange={event =>
        setValue(removeNoNumbersCharactersFromChangeEvent(event).target.value)
      }
      type='text'
    />
  );
}
